import HomePage from '../pages/home-page'
import RegistrationPage from '../pages/registration-page'
import LoginPage from '../pages/login-page'
import ForgotPasswordPage from '../pages/forgot-password-page'
import ResetPasswordPage from '../pages/reset-password-page'
import SettingsProfilePage from '../pages/settings-profile-page'
import SettingsAccountManagementPage from '../pages/settings-account-management-page'
import SettingsListingPage from '../pages/settings-listing-page'
import SettingsBookingsPage from '../pages/settings-bookings-page'
import SettingsReviewsPage from '../pages/settings-reviews-page'
import SettingsMessagesPage from '../pages/settings-messages-page'
import SettingsPayoutsPage from '../pages/settings-payouts-page'
import GameMasterProfilePage from '../pages/game-master-profile-page'
import GameMasterDirectoryPage from '../pages/game-master-directory-page'
import NotFoundPage from '../pages/not-found-page'

const routes = [
    {
        path: '/',
        name: HomePage.name,
        component: HomePage,
        meta: { layout: 'home' },
    },
    {
        path: '/register',
        name: RegistrationPage.name,
        component: RegistrationPage,
        meta: { layout: 'guest' },
    },
    {
        path: '/login',
        name: LoginPage.name,
        component: LoginPage,
        meta: { layout: 'guest' },
    },
    {
        path: '/forgot-password',
        name: ForgotPasswordPage.name,
        component: ForgotPasswordPage,
        meta: { layout: 'guest' },
    },
    {
        path: '/reset-password',
        name: 'user.password.reset',
        component: ResetPasswordPage,
        props: true,
        meta: { layout: 'guest' },
    },
    {
        path: '/gamemaster/:cityDashState/:nameDashId',
        name: GameMasterProfilePage.name,
        component: GameMasterProfilePage,
    },
    {
        path: '/gamemaster/:cityDashState',
        name: GameMasterDirectoryPage.name,
        component: GameMasterDirectoryPage,
    },
    {
        path: '/settings/profile',
        name: SettingsProfilePage.name,
        component: SettingsProfilePage,
        guards: ['auth'],
    },
    {
        path: '/settings/account',
        name: SettingsAccountManagementPage.name,
        component: SettingsAccountManagementPage,
        guards: ['auth'],
    },
    {
        path: '/settings/listing',
        name: SettingsListingPage.name,
        component: SettingsListingPage,
        guards: ['auth'],
    },
    {
        path: '/settings/bookings',
        name: SettingsBookingsPage.name,
        component: SettingsBookingsPage,
        guards: ['auth'],
    },
    {
        path: '/settings/reviews',
        name: SettingsReviewsPage.name,
        component: SettingsReviewsPage,
        guards: ['auth'],
    },
    {
        path: '/settings/messages',
        name: SettingsMessagesPage.name,
        component: SettingsMessagesPage,
        guards: ['auth'],
    },
    {
        path: '/settings/payouts',
        name: SettingsPayoutsPage.name,
        component: SettingsPayoutsPage,
        guards: ['auth'],
    },
    {
        path: '*',
        component: NotFoundPage,
        meta: {
            layout: 'not-found',
            title: '404',
            description: 'Sorry, the content you are looking for doesn’t exist.<br/>Either it was removed, or you mistyped the link.',
        },
    },
]

export default routes
